import React, { useState } from 'react';
import '../../style/Buttons.css'


const ButtonsPractice = () => {
  const [clickMessage, setClickMessage] = useState("");
  const [doubleClickMessage, setDoubleClickMessage] = useState("");
  const [rightClickMessage, setRightClickMessage] = useState("");

  // Handle Standard Click
  const handleLeftClick = () => {
    setClickMessage("You have done a dynamic click");
  };

  // Handle Right Click (Context Menu)
  const handleRightClick = (e) => {
    e.preventDefault(); // Prevents the actual browser right-click menu from opening
    setRightClickMessage("You have done a right click");
  };

  // Handle Double Click
  const handleDoubleClick = () => {
    setDoubleClickMessage("You have done a double click");
  };

  return (
    <div className="col-md-8 col-lg-8 col-xl-8">
      <h1 className="mb-3 fw-normal border-bottom text-left pb-2 mb-4">Buttons</h1>
      
      <div className="button-group">
        <button 
          type="button" 
          className="btn btn-primary" 
          onClick={handleLeftClick}
        >
          <b>Click Me</b>
        </button>

        <button 
          type="button" 
          className="btn btn-secondary" 
          onContextMenu={handleRightClick}
        >
         <b> Right Click Me</b>
        </button>

        <button 
          type="button" 
          className="btn btn-success" 
          onDoubleClick={handleDoubleClick}
        >
          <b>Double Click Me</b>
        </button>
      </div>

      {/* Output Section */}
      <div className="mt-4 message-container">
        {clickMessage && (
          <div className="dynamic-message mb-2">{clickMessage}</div>
        )}
        
        {rightClickMessage && (
          <div className="right-click-message mb-2">{rightClickMessage}</div>
        )}

        {doubleClickMessage && (
          <p className="double-click-text">{doubleClickMessage}</p>
        )}
      </div>
    </div>
  );
};

export default ButtonsPractice;